import { Backdrop } from '@mui/material';

import LogoTenGov from '../../assets/vertical-white-logo.svg';

import './styles.css';

interface LoadingBackdropProps {
  text: string;
  component: any;
  loading: boolean;
}

export const LoadingBackdrop = ({
  text,
  component,
  loading,
}: LoadingBackdropProps) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: theme => theme.zIndex.drawer + 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        fontSize: '17px',
        fontWeight: '600',
        background: 'rgb(0 0 0 / 70%)',
      }}
      open={loading}
    >
      <img
        src={LogoTenGov}
        alt="Logo da Ten Governança"
        style={{ width: '200px' }}
      />
      <div className="container-loading">
        {`${text} ${component}`}
        <div className="lds-ellipsis">
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </Backdrop>
  );
};
